// extracted by mini-css-extract-plugin
module.exports = {"content-section__container":"content-section__container--w4hdh"};